export const specialCharacters:{[key: string]: string[]} = {
  a: [
    "ä",
    "á",
    "à",
    "â",
    "ã",
    "ā",
    "ǎ",
    "å",
    "ă",
    "ą",
    "ǟ",
    "ǡ",
    "ǻ",
    "ȁ",
    "ȃ",
    "ȧ",
    "ạ",
    "ả",
    "ấ",
    "ầ",
    "ẩ",
    "ẫ",
    "ậ",
    "ắ",
    "ằ",
    "ẳ",
    "ẵ",
    "ặ",
  ],
  b: ["ß", "ƀ", "ƃ", "ɓ", "ᵬ", "ᶀ", "ḃ", "ḅ", "ḇ"],
  c: ["ć", "č", "ç", "ĉ", "ċ", "ƈ", "ȼ", "ɕ", "ḉ"],
  d: ["đ", "ď", "ḋ", "ḍ", "ḏ", "ḑ", "ḓ"],
  e: [
    "ë",
    "é",
    "è",
    "ê",
    "ē",
    "ě",
    "ė",
    "ę",
    "ǝ",
    "ȅ",
    "ȇ",
    "ȩ",
    "ɛ",
    "ɘ",
    "ẹ",
    "ẻ",
    "ẽ",
    "ế",
    "ề",
    "ể",
    "ễ",
    "ệ",
  ],
  f: ["ƒ", "ḟ"],
  g: ["ğ", "ĝ", "ġ", "ģ", "ǧ", "ǵ", "ɠ", "ḡ", "ᵹ"],
  h: ["ĥ", "ȟ", "ḩ", "ḥ", "ḫ", "ẖ", "ħ", "ⱨ", "ɦ"],
  i: ["ï", "í", "ì", "î", "ī", "ǐ", "į", "ı", "ɨ", "ỉ", "ị", "ɪ", "ɩ"],
  j: ["ĵ", "ǰ", "ȷ"],
  k: ["ķ", "ƙ", "ḳ", "ḵ", "ⱪ"],
  l: ["ł", "ĺ", "ľ", "ļ", "ŀ", "ḷ", "ḹ", "ḻ", "ḽ", "ȴ"],

  m: ["ṁ", "ṃ", "ᵯ", "ɱ", "ᶆ", "ḿ", "ṁ", "ṃ", "ṇ", "ṅ", "ṉ", "ṋ"],
  n: ["ñ", "ń", "ǹ", "ň", "ņ", "ŋ", "ɲ", "ṅ", "ṇ", "ṉ", "ṋ", "ⁿ"],
  o: [
    "ö",
    "ó",
    "ò",
    "ô",
    "õ",
    "ō",
    "ǒ",
    "ø",
    "ő",
    "ơ",
    "ǫ",
    "ȍ",
    "ȏ",
    "ȫ",
    "ȭ",
    "ȯ",
    "ọ",
    "ỏ",
    "ố",
    "ồ",
    "ổ",
    "ỗ",
    "ộ",
    "ớ",
    "ờ",
    "ở",
    "ỡ",
    "ợ",
  ],
  p: ["þ", "ƥ", "ᵽ", "ᶈ", "ṗ"],
  q: ["ʠ", "ɋ"],
  r: ["ř", "ŕ", "ṙ", "ṛ", "ṝ", "ṟ"],
  s: ["ś", "š", "ş", "ŝ", "ș", "ṡ", "ṣ", "ṥ", "ṧ", "ṩ"],
  t: ["ţ", "ť", "ṫ", "ṭ", "ṯ", "ṱ", "ẗ", "ƭ", "ȶ"],
  u: [
    "ü",
    "ú",
    "ù",
    "û",
    "ū",
    "ǔ",
    "ů",
    "ű",
    "ų",
    "ư",
    "ǘ",
    "ǜ",
    "ǖ",
    "ǚ",
    "ȕ",
    "ȗ",
    "ụ",
    "ủ",
    "ứ",
    "ừ",
    "ử",
    "ữ",
    "ự",
  ],
  v: ["ʋ", "ṿ", "ⱱ", "ʌ"],
  w: ["ẅ", "ẃ", "ẁ", "ŵ", "ẇ", "ẉ", "ⱳ", "ẘ"],
  x: ["ẍ", "ẋ", "ₓ", "✕"],
  y: ["ÿ", "ý", "ỳ", "ŷ", "ÿ", "ỹ", "ȳ", "ɏ", "ƴ", "ʎ", "ẙ", "ỷ", "ỵ"],
  z: ["ž", "ź", "ż", "ẑ", "ẓ", "ẕ"],
};
